import React from 'react';
//import { formatTime as _formatTime } from './helpers'; // (optional helper if you want to place formatting helper separately)

/*
  BookingItem component
  Props:
    - booking: booking object
    - getAvatar: function -> returns avatar string
    - onCancel: function
    - loading: boolean
*/
function formatTime(hour, minute = 0) {
  const period = hour >= 12 ? 'PM' : 'AM';
  const displayHour = hour > 12 ? hour - 12 : hour === 0 ? 12 : hour;
  const displayMinute = minute === 0 ? '00' : String(minute).padStart(2, '0');
  return `${displayHour}:${displayMinute} ${period}`;
}

function BookingItem({ booking, getAvatar, onCancel, loading }) {
  return (
    <div className="booking-item">
      <div className="booking-guru">
        <span className="booking-avatar">{getAvatar()}</span>
        <div className="booking-info-mini">
          <div className="booking-name">{booking.guru_name}</div>
          <div className="booking-consultation">{booking.consultation_name}</div>
        </div>
      </div>

      <div className="booking-details-mini">
        <div className="">{new Date(booking.booking_date).toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' })}</div>
        <div className="consult-duration">{formatTime(booking.start_hour, booking.start_minute)}</div>
        <div className="booking-credits">💳 {booking.credits_used}</div>
        <div className={`booking-status status-${booking.status}`}>{booking.status}</div>
      </div>

      <div className="booking-actions">
        {booking.status === 'confirmed' && (
          <button className="cancel-btn" onClick={onCancel} disabled={loading}>
            {loading ? '...' : ' Cancel'}
          </button>
        )}
      </div>
    </div>
  );
}

export default React.memo(BookingItem);